/**
 * @file useMediaQuery.ts
 * @description Подписка на медиазапрос (phase19.29): `true`, пока запрос
 * выполняется. Нужен каркасу кабинета, у которого порог закрепления боковой
 * панели задаётся параметром (md у магазина, lg у платформы), и заголовку
 * страницы, которому важна именно ширина телефона.
 */

import { useEffect, useState } from "react";

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(query).matches : false,
  );
  useEffect(() => {
    const mq = window.matchMedia(query);
    // Запрос мог смениться между рендером и эффектом — сверяемся сразу.
    setMatches(mq.matches);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [query]);
  return matches;
}

/** Телефон: уже 768px (Tailwind md). */
export const PHONE_QUERY = "(max-width: 767.98px)";
/** Уже 1024px (Tailwind lg) — телефон и планшет. */
export const BELOW_LG_QUERY = "(max-width: 1023.98px)";
/** От 1024px (Tailwind lg). */
export const LG_QUERY = "(min-width: 1024px)";
/** От 1280px — «Настройки» в две колонки (список разделов слева, раздел справа). */
export const WIDE_QUERY = "(min-width: 1280px)";
